/* Olle hero slideshow — autoplay w/ pause on hover, dots, arrows, swipe, video play/pause */
(function () {
  function init(root) {
    if (root.dataset.heroInit) return;
    root.dataset.heroInit = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('.olle-hero__slide'));
    if (!slides.length) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-go]'));
    var pauseBtn = root.querySelector('[data-hero-pause]');
    var autoplay = root.dataset.autoplay === 'true' && slides.length > 1;
    var interval = parseInt(root.dataset.interval, 10) || 6000;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur = 0, timer = null, paused = reduced || !autoplay, hovering = false;

    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === cur;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        var v = s.querySelector('video');
        if (v) { v.muted = true; if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }
      });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
    }
    function tick() { if (!paused && !hovering && !document.hidden) show(cur + 1); }
    function start() { stop(); if (autoplay) timer = setInterval(tick, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    root.addEventListener('mouseenter', function () { hovering = true; });
    root.addEventListener('mouseleave', function () { hovering = false; });
    var prev = root.querySelector('[data-hero-prev]'), next = root.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); start(); });
    if (next) next.addEventListener('click', function () { show(cur + 1); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.dataset.heroGo, 10)); start(); }); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      paused = !paused;
      pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
    });

    // swipe
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = y0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { show(dx < 0 ? cur + 1 : cur - 1); start(); }
    }, { passive: true });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(cur - 1); start(); }
      if (e.key === 'ArrowRight') { show(cur + 1); start(); }
    });

    show(0);
    start();
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        var s = e.target.closest && e.target.closest('.olle-hero__slide');
        if (s && root.contains(s)) { paused = true; show(parseInt(s.dataset.slide, 10)); }
      });
    }
  }
  function boot() { document.querySelectorAll('[data-olle-hero]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
